import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import { confirmResetPassword, confirmSignIn as cognitoConfirmSignIn, confirmSignUp as cognitoConfirmSignUp, confirmUserAttribute, fetchAuthSession, fetchMFAPreference, fetchUserAttributes, getCurrentUser, resendSignUpCode, resetPassword, sendUserAttributeVerificationCode, setUpTOTP as cognitoSetUpTOTP, signIn as cognitoSignIn, signOut as cognitoSignOut, signUp as cognitoSignUp, updateMFAPreference, updatePassword, updateUserAttributes, verifyTOTPSetup } from 'aws-amplify/auth';
import axios from "axios";
import { defaultUser, LANGUAGE_COOKIE, sendSoftwareUserUpdate, setUserFromCognitoSession } from "../../model/User";
import { addQueryStringValueToUrl, QueryStringGetter, setCookie } from "../../model/Utilities";
import { flushCachedFavorites } from "../../model/DigitalContentFavorite";
import { ADMIN_UPDATE_ATTRIBUTE_ACTION, ADMIN_UPDATE_MFA, logChange, UPDATE_ATTRIBUTE_ACTION, UPDATE_MFA } from "../../model/ChangeLog";
import { Amplify } from "aws-amplify";
import { TOKENS_CACHE_KEY } from "../../model/AiToken";
export const BLACKLISTED_USERNAMES = ['admin', 'cognito', 'data-export', 'email', 'meta-data', 'product-registration', 'promo-code', 'romeo-rollholder-email', 'set-mfa-preference', 'sign-in-log', 'software-sessions', 'software-user', 'username'];

// global vars
let loadedFromQueryString = false;
let authConfig = {
  Cognito: {
    userPoolId: process.env.USER_POOL_ID ?? '',
    userPoolClientId: process.env.USER_POOL_CLIENT_ID ?? ''
  }
};
Amplify.configure({
  Auth: authConfig
});
export function addAuthTokensToUrl(url, callback) {
  cognitoAuthenticatedUser(user => {
    url = addQueryStringValueToUrl(url, 'accessToken', user.signInUserSession['accessToken']['jwtToken']);
    url = addQueryStringValueToUrl(url, 'idToken', user.signInUserSession['idToken']['jwtToken']);
    let refreshToken = extractRefreshTokenFromLocalStorage(user.username);
    if (refreshToken) {
      url = addQueryStringValueToUrl(url, 'refreshToken', refreshToken);
    }
    callback(url);
  }, err => {
    console.log('User not authenticated. Redirecting without auth tokens.', err);
    callback(url);
  });
}
export function attemptQueryStringSignIn() {
  const query = QueryStringGetter();
  const accessToken = query().get('accessToken');
  const idToken = query().get('idToken');
  const refreshToken = query().get('refreshToken');
  if (accessToken && idToken && refreshToken) {
    tokenSignIn(accessToken, idToken, refreshToken);
    loadedFromQueryString = true;
    return true;
  } else return false;
}

// noinspection JSUnusedGlobalSymbols
export function cognitoAuthenticatedUser(callback, errorCallback) {
  getCurrentUser().then(user => {
    fetchAuthSession().then(session => {
      fetchUserAttributes().then(attributes => {
        fetchMFAPreference().then(mfaOutput => {
          callback(cognitoAuthUserToInternalCognitoUser(user, attributes, session, mfaOutput));
        }).catch(err => {
          errorCallback(err);
        });
      }).catch(err => {
        errorCallback(err);
      });
    }).catch(err => {
      errorCallback(err);
    });
  }).catch(err => {
    errorCallback(err);
  });
}
export function confirmSignIn(accessCode, successCallback, errorCallback) {
  cognitoConfirmSignIn({
    challengeResponse: accessCode
  }).then(data => {
    successCallback(data);
  }).catch(err => {
    errorCallback(err);
  });
}
export function confirmSignup(username, confirmAccountCode, thenCallback, catchCallback) {
  cognitoConfirmSignUp({
    confirmationCode: confirmAccountCode,
    username: username
  }).then(thenCallback).catch(catchCallback);
}
export function currentSession(thenCallback, catchCallback) {
  fetchAuthSession().then(session => {
    thenCallback(cognitoAuthSessionToInternalCognitoSession(session));
  }).catch(err => {
    catchCallback(err);
  });
}
export async function fetchSignedInCognitoUserAttributes() {
  return fetchUserAttributes();
}
export function forgotPassword(username, thenCallback, catchCallback) {
  resetPassword({
    username: username
  }).then(thenCallback).catch(catchCallback);
}
export function forgotPasswordSubmit(username, forgotPasswordCode, newPassword, thenCallback, catchCallback) {
  confirmResetPassword({
    confirmationCode: forgotPasswordCode,
    newPassword: newPassword,
    username: username
  }).then(thenCallback).catch(catchCallback);
}
export function handleModalSignInSuccess(setUser) {
  fetchAuthSession().then(authenticatedSession => {
    userFromCurrentSession(user => {
      setUser(user);
      fetchUserAttributes().then(attributes => {
        if (typeof attributes.preferred_username === 'undefined') {
          let newUser = {
            ...user,
            'preferred_username': user.email
          };
          saveAttributes(newUser, () => {}, err => {
            console.log(err);
          }, user, () => {});
        }
      }).catch(err => {
        console.log(err);
      });

      // log the sign-in success
      logSignInSuccess(user.id, cognitoAuthSessionToInternalCognitoSession(authenticatedSession), () => {}, () => {});
    });
  }).catch(err => {
    console.log(err);
  });
}
export function logSignInSuccess(sub, authenticatedSession, successCallback, errorCallback) {
  axios.post(process.env.SISER_API_ENDPOINT + 'user/sign-in-log', {
    'sub': sub
  }, {
    headers: {
      "Authorization": authenticatedSession['idToken']['jwtToken']
    }
  }).then(data => {
    successCallback(data);
  }).catch(err => {
    errorCallback(err);
  });
}

// noinspection JSUnusedGlobalSymbols
export function redirectWithSessionValues(redirectUrl) {
  sendToUrlWithAuthTokens(redirectUrl, false);
}
export function resendSignup(username, thenCallback, catchCallback) {
  resendSignUpCode({
    username: username
  }).then(thenCallback).catch(catchCallback);
}
export function saveAttributes(newUser, successCallback, errorCallback, user, setUser, isProxyUpdate) {
  let attributesObj = {};
  let originalObj = {};
  if (typeof newUser.avatar !== 'undefined' && newUser.avatar !== user.avatar) {
    attributesObj['custom:avatar'] = newUser.avatar;
    originalObj['custom:avatar'] = user.avatar;
  }
  if (typeof newUser.countryCode !== 'undefined' && newUser.countryCode !== user.countryCode) {
    attributesObj['custom:country_code'] = newUser.countryCode.toUpperCase();
    originalObj['custom:country_code'] = user.countryCode.toUpperCase();
  }
  if (typeof newUser.timezone !== 'undefined' && newUser.timezone && newUser.timezone !== user.timezone) {
    attributesObj['custom:timezone'] = newUser.timezone;
    originalObj['custom:timezone'] = user.timezone;
  }
  if (typeof newUser.preferred_username === 'undefined') {
    attributesObj['preferred_username'] = user.email;
    originalObj['preferred_username'] = user.email;
  }
  if (typeof newUser.email !== 'undefined' && newUser.email !== user.email) {
    attributesObj['email'] = newUser.email;
    originalObj['email'] = user.email;
    attributesObj['preferred_username'] = newUser.email;
    originalObj['preferred_username'] = user.email;
  }
  if (typeof newUser.email_verified !== 'undefined' && newUser.email_verified !== user.email_verified) {
    attributesObj['email_verified'] = newUser.email_verified;
  }
  if (typeof newUser.firstName !== 'undefined' && newUser.firstName !== user.firstName) {
    attributesObj['given_name'] = newUser.firstName;
    originalObj['given_name'] = user.firstName;
  }
  if (typeof newUser.lastName !== 'undefined' && newUser.lastName !== user.lastName) {
    attributesObj['family_name'] = newUser.lastName;
    originalObj['family_name'] = user.lastName;
  }
  if (typeof newUser.languageCode !== 'undefined' && newUser.languageCode !== user.languageCode) {
    attributesObj['custom:language_code'] = newUser.languageCode;
    originalObj['custom:language_code'] = user.languageCode;
    setCookie(LANGUAGE_COOKIE, newUser.languageCode, 150);
  }
  if (typeof newUser.phoneNumber !== 'undefined' && newUser.phoneNumber !== user.phoneNumber) {
    attributesObj['phone_number'] = newUser.phoneNumber;
    originalObj['phone_number'] = user.phoneNumber;
  }
  if (typeof newUser.isNewsletterSubscriber !== 'undefined' && newUser.isNewsletterSubscriber !== user.isNewsletterSubscriber) {
    attributesObj['custom:newsletter'] = newUser.isNewsletterSubscriber ? "1" : "0";
    originalObj['custom:newsletter'] = newUser.isNewsletterSubscriber ? "1" : "0";
  }
  if (newUser.role !== user.role) {
    attributesObj['custom:role'] = newUser.role;
    originalObj['custom:role'] = newUser.role;
  }

  // if there is nothing to update, we simply act like it was successful
  if (Object.keys(attributesObj).length === 0 && (typeof newUser['newPassword'] === 'undefined' || newUser['newPassword'].length === 0)) {
    successCallback(newUser);
    return;
  }

  // in this case, we'll update via the API
  if (typeof isProxyUpdate !== 'undefined' && isProxyUpdate) {
    if (typeof newUser['newPassword'] !== 'undefined' && newUser['newPassword'].length !== 0) {
      attributesObj.password = newUser.password;
    }
    fetchAuthSession().then(session => {
      if (typeof session['tokens'] === 'undefined' || typeof session['tokens']['accessToken'] === 'undefined' || typeof session['tokens']['idToken'] === 'undefined') {
        errorCallback(new Error('No authenticated session found, so it is not possible to save attributes at this time.'));
        return;
      }
      const requestBody = {
        attributes: attributesObj,
        username: user.username
      };
      axios.patch(process.env.SISER_API_ENDPOINT + 'user/cognito', requestBody, {
        headers: {
          "Authorization": session.tokens.idToken.toString()
        }
      }).then(response => {
        if (response.status === 200) {
          logChange("Update User", originalObj, attributesObj, ADMIN_UPDATE_ATTRIBUTE_ACTION, session.tokens?.accessToken?.payload['sub'] ?? '', user.id);
          setUser(newUser);
          successCallback(response.data);
          sendSoftwareUserUpdate(cognitoAuthSessionToInternalCognitoSession(session), user);
          if (typeof attributesObj['custom:role'] !== 'undefined') {
            sendRoleChangeEmail(newUser.email, user.role, newUser.role, session.tokens?.idToken?.toString() ?? '');
          }
        }
      }).catch(e => {
        if (typeof e.response.data !== 'undefined' && typeof e.response.data['errorMessage'] !== 'undefined') {
          errorCallback(e.response.data['errorMessage']);
        } else {
          errorCallback('An unknown error occurred: ' + JSON.stringify(e.message));
        }
      });
    }).catch(err => {
      errorCallback(err);
    });
  } else {
    fetchAuthSession().then(session => {
      updateUserAttributes({
        userAttributes: attributesObj
      }).then(() => {
        fetchAuthSession({
          forceRefresh: true
        }).then(() => {
          logChange("Update User", originalObj, attributesObj, UPDATE_ATTRIBUTE_ACTION, user.id, user.id);

          // if passwords are involved, save them with a separate call
          // delete them before saving the state to avoid security issues
          if (typeof newUser.password !== 'undefined' && typeof newUser['newPassword'] !== 'undefined') {
            updatePassword({
              oldPassword: newUser.password,
              newPassword: newUser.newPassword
            }).then(data => {
              delete newUser.password;
              delete newUser['newPassword'];
              setUser(newUser);
              successCallback(data);
              sendSoftwareUserUpdate(cognitoAuthSessionToInternalCognitoSession(session), newUser);
            }).catch(e => {
              errorCallback(e);
            });
          } else {
            setUser(newUser);
            successCallback(newUser);
          }
        });
      }).catch(e => {
        errorCallback(e);
      });
    }).catch(e => {
      errorCallback(e);
    });
  }
}
export function sendToUrlWithAuthTokens(url, newTab) {
  addAuthTokensToUrl(url, newUrl => {
    if (typeof window !== 'undefined') {
      if (typeof newTab !== 'undefined' && newTab) {
        window.open(newUrl, '_blank');
      } else {
        window.location.href = newUrl;
      }
    }
  });
}
export function setEmailtoPreferredUsername(preferred_username) {
  userFromCurrentSession(user => {
    saveAttributes({
      ...user,
      email: preferred_username
    }, () => {}, err => {
      console.log(err);
    }, user, () => {});
  });
}
export function setPreferredUsernameToEmail(email) {
  userFromCurrentSession(user => {
    saveAttributes({
      ...user,
      preferred_username: email
    }, () => {}, err => {
      console.log(err);
    }, user, () => {});
  });
}
export function setUpTOTP(successCallback, errorCallback) {
  cognitoSetUpTOTP().then(data => {
    successCallback(data);
  }).catch(err => {
    errorCallback(err);
  });
}
export function signIn(username, password, thenCallback, catchCallback) {
  cognitoSignIn({
    username,
    password
  }).then(response => {
    setCognitoUserExtendedFromSignInOutput(response, thenCallback, catchCallback);
    if (typeof window['gtag'] !== 'undefined') {
      window['gtag']('event', 'login');
    }
  }).catch(catchCallback);
}
export function signOut(successCallback, errorCallback, userId) {
  cognitoSignOut().then(() => {
    successCallback();

    // flush the cached data
    if (typeof userId !== 'undefined' && typeof window !== 'undefined') {
      window.sessionStorage.removeItem('siser-user-owned-models-' + userId);
      window.sessionStorage.removeItem('user-meta-data-' + userId);
      window.sessionStorage.removeItem(TOKENS_CACHE_KEY);
      flushCachedFavorites(userId);
    }
  }).catch(e => {
    errorCallback(e);
  });
}
export function signUp(params, thenCallback, catchCallback) {
  // pre-checks
  if (BLACKLISTED_USERNAMES.includes(params.username)) {
    catchCallback(new Error("Your desired username is unavailable."));
    return;
  }

  // sign up
  cognitoSignUp(params).then(thenCallback).catch(catchCallback);
}
export function tokenSignIn(accessTokenVal, idTokenVal, refreshTokenVal) {
  const accessToken = new AmazonCognitoIdentity.CognitoAccessToken({
    AccessToken: accessTokenVal
  });
  const idToken = new AmazonCognitoIdentity.CognitoIdToken({
    IdToken: idTokenVal
  });
  const refreshToken = new AmazonCognitoIdentity.CognitoRefreshToken({
    RefreshToken: refreshTokenVal
  });
  const session = new AmazonCognitoIdentity.CognitoUserSession({
    IdToken: idToken,
    AccessToken: accessToken,
    RefreshToken: refreshToken
  });
  const userPool = new AmazonCognitoIdentity.CognitoUserPool({
    UserPoolId: process.env.USER_POOL_ID ?? '',
    ClientId: process.env.USER_POOL_CLIENT_ID ?? ''
  });
  const cognitoUser = new AmazonCognitoIdentity.CognitoUser({
    Username: accessToken.payload.username,
    Pool: userPool
  });
  cognitoUser.setSignInUserSession(session);
}
export function updateMFA(mfaSetting, user, setUser, cognitoUser, callback, errorCallback, isProxyUpdate) {
  if (typeof isProxyUpdate !== 'undefined' && isProxyUpdate) {
    const requestBody = {
      mfa_option: mfaSetting
    };
    axios.put(process.env.SISER_API_ENDPOINT + 'user/' + user.username + '/mfa-preference', requestBody, {
      headers: {
        "Authorization": cognitoUser['signInUserSession']['idToken']['jwtToken'],
        'X-Siser-Elevated-Roles': '1'
      }
    }).then(response => {
      if (response.status === 200) {
        logChange('Update MFA', {
          'MFA': user.MFA
        }, {
          'MFA': mfaSetting
        }, ADMIN_UPDATE_MFA, cognitoUser.attributes.sub, user.id);
        let tmpUser = {
          ...user
        };
        tmpUser.MFA = mfaSetting;
        setUser(tmpUser);
        callback(response.data);
      }
    }).catch(e => {
      if (typeof e.response.data !== 'undefined' && typeof e.response.data['errorMessage'] !== 'undefined') {
        errorCallback(e.response.data['errorMessage']);
      } else {
        errorCallback('An unknown error occurred: ' + JSON.stringify(e.message));
      }
    });
  } else {
    updateMFAPreference(mfaOptionsToUpdateMFAPreferenceInput(mfaSetting)).then(data => {
      logChange('Update MFA', {
        'MFA': user.MFA
      }, {
        'MFA': mfaSetting
      }, UPDATE_MFA, cognitoUser.attributes.sub, user.id);
      let tmpUser = {
        ...user
      };
      tmpUser.MFA = mfaSetting;
      setUser(tmpUser);
      callback(data);
    }).catch(err => {
      errorCallback(err);
    });
  }
}
export function userFromCurrentSession(setUserCallback, autoRefreshTokens) {
  fetchAuthSession({
    forceRefresh: typeof autoRefreshTokens !== 'undefined' && autoRefreshTokens
  }).then(session => {
    if (!session.userSub) {
      setUserCallback({
        ...defaultUser(),
        ...{
          cognitoChecked: true
        }
      });
      return;
    }
    fetchMFAPreference().then(mfaData => {
      setUserFromCognitoSession(cognitoAuthSessionToInternalCognitoSession(session), cognitoFetchMfaPreferenceOutputToMfaOptions(mfaData), setUserCallback, err => {
        handleAuthenticationError(err, setUserCallback);
      });
    }).catch(mfaErr => {
      console.log('authentication error 2: ', mfaErr);
      handleAuthenticationError(mfaErr, setUserCallback);
    });
  }).catch(err => {
    console.log('authentication error 3: ', err);
    handleAuthenticationError(err, setUserCallback);
  });
}
export function verifyTOTP(accessCode, successCallback, errorCallback) {
  verifyTOTPSetup({
    code: accessCode
  }).then(() => {
    successCallback();
  }).catch(err => {
    errorCallback(err);
  });
}
export function verifyUserAttribute(attributeKey, thenCallback, catchCallback) {
  sendUserAttributeVerificationCode({
    userAttributeKey: attributeKey
  }).then(thenCallback).catch(catchCallback);
}
export function verifyUserAttributeSubmit(attributeKey, code, thenCallback, catchCallback) {
  confirmUserAttribute({
    confirmationCode: code,
    userAttributeKey: attributeKey
  }).then(thenCallback).catch(catchCallback);
}

// private functions
function cognitoAuthSessionToInternalCognitoSession(session) {
  return {
    accessToken: {
      jwtToken: session.tokens?.accessToken?.toString() ?? ''
    },
    idToken: {
      jwtToken: session.tokens?.idToken?.toString() ?? '',
      payload: session.tokens?.idToken?.payload ?? {}
    },
    refreshToken: {
      token: ''
    }
  };
}
function cognitoAuthUserToInternalCognitoUser(cognitoUser, attributes, session, fetchMFAOutput) {
  return {
    attributes: attributes,
    challengeName: cognitoFetchMfaPreferenceOutputToMfaOptions(fetchMFAOutput),
    signInUserSession: cognitoAuthSessionToInternalCognitoSession(session),
    username: cognitoUser.username
  };
}
function cognitoFetchMfaPreferenceOutputToMfaOptions(mfaPref) {
  if (typeof mfaPref['enabled'] === 'undefined' || mfaPref.enabled.length === 0) {
    return 'NOMFA';
  }
  for (let i = 0; i < mfaPref.enabled.length; i++) {
    switch (mfaPref.enabled[i]) {
      case 'SMS':
        return "SMS_MFA";
      case "TOTP":
        return "TOTP";
    }
  }
  return "NOMFA";
}
function extractRefreshTokenFromLocalStorage(username) {
  let refreshToken = '';
  if (typeof window !== 'undefined' && typeof window['localStorage'] !== 'undefined') {
    Object.keys(window.localStorage).forEach(key => {
      if (key.startsWith('CognitoIdentityServiceProvider') && key.endsWith(username + '.refreshToken')) {
        refreshToken = window.localStorage.getItem(key) ?? '';
        return;
      }
    });
  }
  return refreshToken;
}
function handleAuthenticationError(err, setUserCallback) {
  let tmpUser = defaultUser();
  tmpUser.cognitoChecked = true;
  if (typeof err === 'undefined') {
    console.log('Unknown error case for handleAuthenticationUser.');
    setUserCallback(tmpUser);
    return;
  }
  if (typeof err.name !== 'undefined' && err.name.includes('NotAuthorizedException') || typeof err.name !== 'undefined' && err.name.includes('not authorized exception')) {
    console.log('NotAuthorizedException error for user...', tmpUser);
    setUserCallback(tmpUser);
    return;
  }
  if (!loadedFromQueryString && attemptQueryStringSignIn()) {
    loadedFromQueryString = true;
    userFromCurrentSession(setUserCallback, false);
    return;
  }
  console.log('default authentication error case: ', tmpUser, err);
  setUserCallback(tmpUser);
}
function mfaOptionsToUpdateMFAPreferenceInput(mfaOptions) {
  let input = {
    sms: "DISABLED",
    totp: "DISABLED"
  };
  switch (mfaOptions) {
    case "SMS_MFA":
      input.sms = "ENABLED";
      break;
    case "SOFTWARE_TOKEN_MFA":
    case "TOTP":
      input.totp = "ENABLED";
  }
  return input;
}
function sendRoleChangeEmail(email, previousRole, newRole, idToken) {
  axios.patch(process.env.SISER_API_ENDPOINT + 'notification/role', {
    'email': email,
    'new_role': newRole,
    'previous_role': previousRole
  }, {
    'headers': {
      'Authorization': 'Bearer ' + idToken,
      'X-Siser-Elevated-Roles': '1'
    }
  }).then(() => {}).catch(() => {});
}
function setCognitoUserExtendedFromSignInOutput(output, setCogUser, catchCallback) {
  if (output.isSignedIn || output.nextStep.signInStep === 'DONE') {
    cognitoAuthenticatedUser(user => {
      setCogUser(user);
    }, catchCallback);
  } else {
    let user = {
      attributes: {},
      challengeName: "NOMFA",
      signInUserSession: {
        accessToken: {
          jwtToken: ""
        },
        idToken: {
          jwtToken: "",
          payload: {}
        },
        refreshToken: {
          token: ''
        }
      },
      username: ""
    };
    switch (output.nextStep.signInStep) {
      case "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE":
      case "CONTINUE_SIGN_IN_WITH_MFA_SELECTION":
      case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
      case "CONFIRM_SIGN_UP":
      case "RESET_PASSWORD":
        catchCallback(new Error("No method yet created to handle next step \"" + output.nextStep.signInStep + "\""));
        break;
      case "CONFIRM_SIGN_IN_WITH_SMS_CODE":
        user.challengeName = "SMS_MFA";
        break;
      case "CONFIRM_SIGN_IN_WITH_TOTP_CODE":
        user.challengeName = "SOFTWARE_TOKEN_MFA";
    }
    setCogUser(user);
  }
}
// end private functions